<template>
  <div class="w-full h-full flex">
    <input
      v-model.trim="value"
      v-validate="'required'"
      name="password"
      class="h-full border-0 w-full px-2 bg-transparent rounded-lg font-family"
      :class="{ 'border-danger': errors.first('password') }"
      :type="typeInput"
      @input="$emit('input', value)"
    />
    <button class="w-1/6 border-0 rounded-r-lg cursor-pointer" @click="eye = !eye">
      <feather-icon :icon="EyeIcon" svgClasses="w-5 h-5" />
    </button>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      value: this.value,
      eye: true
    };
  },
  computed: {
    EyeIcon() {
      return this.eye ? "EyeOffIcon" : "EyeIcon";
    },
    typeInput() {
      return this.eye ? "password" : "text";
    }
  }
};
</script>

<style lang="scss" scpoped>
.border-danger {
  border: 1px solid rgba(234, 84, 85, 1) !important;
}

.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
}
</style>
